/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from "react"
import { httpGet } from "../services/Http.service"
import { AxiosResponse } from "axios"
import { Service, ServiceType } from "../types/service.type"
import { apiUrl } from "../configs/config.constants"
import { DataContext, ProjectContext } from "../App"

export function useGetServices() {
  const { project } = useContext(ProjectContext)
  const { services, setServices, serviceTypes, setServiceTypes } = useContext(DataContext)

  useEffect(() => {
    if (project?.projectId && project?.roleAccess?.booking) {
      getServices()
    }
  }, [project?.projectId])

  useEffect(() => {
    getServiceTypes()
  }, [services])

  function getServices() {
    if (services.length > 0) return

    httpGet(apiUrl.service.list, {
      limit: 100,
      skip: 0,
    })
      .then((response: AxiosResponse<Service[]>) => {
        const services = response.data
        setServices(services)
      })
      .catch((error: any) => {
        console.error(error)
      })
  }

  function getServiceTypes() {
    httpGet(apiUrl.service.listServiceTypes, {
      limit: 100,
      skip: 0,
    })
      .then((response: AxiosResponse<ServiceType[]>) => {
        const serviceTypes = response.data

        const filteredServiceTypes = serviceTypes.filter((serviceType) => {
          return services.some((service) => service.serviceTypeId === serviceType.serviceTypeId)
        })

        setServiceTypes(filteredServiceTypes)
      })
      .catch((error: any) => {
        console.error(error)
      })
  }

  return {
    services,
    serviceTypes,
  }
}